var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorario(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "relogio icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 68",
    cx: 16,
    cy: 15.9999,
    r: 15.5,
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 324",
    x: 14,
    y: 16.9999,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 325",
    x: 14,
    y: 17.9999,
    width: 10,
    height: 1,
    rx: 0.5,
    transform: "rotate(-90 14 17.9999)",
    fill: "#D91F05"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorario);
export default __webpack_public_path__ + "static/media/horario.117e09978d0cf84affcc96f5c9ae3eec.svg";
export { ForwardRef as ReactComponent };